import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-purple-600/10" />
      <div className="max-w-7xl mx-auto relative">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <Badge className="bg-blue-600/20 text-blue-400 border-blue-600/30" data-testid="hero-badge">
              Digital Venture Studio
            </Badge>
            <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight" data-testid="hero-title">
              Building Tomorrow's
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
                Digital Ventures
              </span>
            </h1>
            <p className="text-xl text-slate-300" data-testid="hero-description">
              Nexus Creative Group LLC builds cutting-edge digital platforms from concept to launch. 
              From premium social networks to enterprise solutions, we transform innovative ideas into powerful digital experiences.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button onClick={() => scrollToSection('portfolio')} size="lg" className="bg-blue-600 hover:bg-blue-700" data-testid="hero-portfolio-button">
                View Our Work <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
              <Button onClick={() => scrollToSection('contact')} size="lg" variant="outline" className="border-slate-600 text-white hover:bg-slate-800" data-testid="hero-contact-button">
                Let's Talk
              </Button>
            </div>
          </div>
          <div className="relative" data-testid="hero-image-container">
            <img 
              src="https://images.unsplash.com/photo-1609619385076-36a873425636" 
              alt="Technology Innovation" 
              className="rounded-lg shadow-2xl"
              data-testid="hero-image"
            />
            <div className="absolute -bottom-4 -left-4 bg-blue-600 text-white p-4 rounded-lg shadow-xl">
              <div className="text-3xl font-bold">10+</div>
              <div className="text-sm">Projects Launched</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;